import { render, staticRenderFns } from "./ModalEmergencyMsg.vue?vue&type=template&id=2e5202e4"
import script from "./ModalEmergencyMsg.vue?vue&type=script&lang=js"
export * from "./ModalEmergencyMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports